import { PlanPillLabel, PlanPillState } from './PlanPill.types'
import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { getPlanTypeName } from '@app/common/src/utils/getPlanTypeName'
import { pillBackgroundColorsByLabelV2, pillTextColorsByLabelV2 } from './PlanPill.constants'
import { useBillingPlanType } from '@app/common/src/hooks/useBillingPlanType/useBillingPlanType'

const planPillLabelByPlanType: Record<PlanType, PlanPillLabel> = {
  [PlanType.ENTERPRISE]: PlanPillLabel.ENTERPRISE,
  [PlanType.PILOT]: PlanPillLabel.PILOT,
  [PlanType.PRO_FLEX]: PlanPillLabel.PRO_FLEX,
  [PlanType.PRO_PLUS_ORG]: PlanPillLabel.PRO_PLUS,
  [PlanType.PRO]: PlanPillLabel.PRO,
  [PlanType.FREE]: PlanPillLabel.FREE
}

export function usePlanPillStateV2(): PlanPillState {
  const planType = useBillingPlanType() || PlanType.FREE
  const label = planPillLabelByPlanType[planType]
  return {
    labelText: getPlanTypeName(planType),
    color: pillTextColorsByLabelV2[label],
    backgroundColor: pillBackgroundColorsByLabelV2[label]
  }
}
